var PetHealth = (function () {
  'use strict';

  const STYLES = `
:host {
  display: block;
  font-family: inherit;
  --ph-primary:  #073056;
  --ph-accent:   #44c8d8;
  --ph-gold:     #f4b700;
  --ph-danger:   #e81c08;
  --ph-success:  #22c55e;
  --ph-text:     #0f172a;
  --ph-muted:    #64748b;
  --ph-bg:       #ffffff;
  --ph-surface:  #f8fafc;
  --ph-surface2: #f1f5f9;
  --ph-border:   #e2e8f0;
  --ph-radius:   14px;
  --ph-shadow:   0 1px 3px rgba(7,48,86,.06), 0 4px 16px rgba(7,48,86,.08);
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Widget shell ── */
.ph-widget {
  background: var(--ph-bg);
  border: 1px solid var(--ph-border);
  border-radius: var(--ph-radius);
  overflow: hidden;
  box-shadow: var(--ph-shadow);
}

/* ── Tabs ── */
.ph-tabs {
  display: flex;
  background: var(--ph-surface);
  border-bottom: 1px solid var(--ph-border);
}

.ph-tab {
  flex: 1;
  padding: 14px 12px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--ph-muted);
  letter-spacing: 0.2px;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.ph-tab:hover { color: var(--ph-primary); background: rgba(7,48,86,.04); }
.ph-tab--active { color: var(--ph-primary); border-bottom-color: var(--ph-primary); background: var(--ph-bg); }

/* ── Panels ── */
.ph-panels { }
.ph-panel--hidden { display: none; }

/* ══════════════════════════════════════════════
   WEIGHT TRACKER
══════════════════════════════════════════════ */

.wt-root { display: flex; flex-direction: column; gap: 0; }

/* ── Form ── */
.wt-form {
  padding: 16px 16px 12px;
  border-bottom: 1px solid var(--ph-border);
  background: var(--ph-surface);
}

.wt-form-inner {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.wt-input-wrap {
  position: relative;
  flex: 0 0 96px;
}

.wt-input-unit {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: var(--ph-muted);
  pointer-events: none;
}

.wt-input {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid var(--ph-border);
  border-radius: 9px;
  font-family: inherit;
  font-size: 14px;
  color: var(--ph-text);
  background: var(--ph-bg);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  -webkit-appearance: none;
}
.wt-input:focus {
  border-color: var(--ph-primary);
  box-shadow: 0 0 0 3px rgba(7,48,86,.09);
}
.wt-input-kg { padding-right: 30px; }
.wt-input-note { flex: 1; }

.wt-add-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: var(--ph-primary);
  color: #fff;
  border: none;
  border-radius: 9px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s, transform 0.1s;
  flex-shrink: 0;
}
.wt-add-btn:hover { opacity: 0.87; }
.wt-add-btn:active { transform: scale(0.96); }

/* ── Chart shell ── */
.wt-chart-shell {
  padding: 16px 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Stats ── */
.wt-stats {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wt-stat--hero {
  background: var(--ph-primary);
  color: #fff;
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  align-items: baseline;
  gap: 3px;
  flex-shrink: 0;
}
.wt-stat--hero .wt-stat-num { font-size: 22px; font-weight: 800; line-height: 1; }
.wt-stat--hero .wt-stat-unit { font-size: 12px; font-weight: 600; opacity: 0.75; }
.wt-stat--hero .wt-stat-lbl {
  font-size: 10px; opacity: 0.65; font-weight: 500;
  display: block; margin-top: 1px;
}

/* Stack hero num+unit and lbl */
.wt-stat--hero {
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
}
.wt-stat--hero-row { display: flex; align-items: baseline; gap: 2px; }

.wt-stat-group {
  display: flex;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.wt-stat--sm {
  flex: 1;
  max-width: 80px;    /* prevents desktop stretching */
  background: var(--ph-surface2);
  border-radius: 10px;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.wt-stat--sm .wt-stat-num { font-size: 14px; font-weight: 700; color: var(--ph-text); }
.wt-stat--sm .wt-stat-lbl { font-size: 9px; font-weight: 500; color: var(--ph-muted); text-transform: uppercase; letter-spacing: 0.3px; }

.wt-delta {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 11px;
  border-radius: 10px;
  flex-shrink: 0;
}
.wt-delta-val { font-size: 13px; font-weight: 800; }
.wt-delta-lbl { font-size: 9px; font-weight: 500; opacity: 0.7; white-space: nowrap; }
.wt-delta--up    { background: rgba(232,28,8,.08);  color: var(--ph-danger); }
.wt-delta--down  { background: rgba(34,197,94,.1);  color: var(--ph-success); }
.wt-delta--stable{ background: var(--ph-surface2); color: var(--ph-muted); }

/* ── Chart wrap + tooltip ── */
.wt-chart-wrap {
  position: relative;
  background: var(--ph-surface);
  border-radius: 12px;
  border: 1px solid var(--ph-border);
  padding: 12px 0 4px;   /* 0 horizontal padding — SVG fills full width */
  overflow: hidden;
}

.wt-svg { display: block; max-width: 100%; touch-action: pan-y; }
#wt-svg-slot { overflow: hidden; }

.wt-tooltip {
  position: absolute;
  background: var(--ph-primary);
  color: #fff;
  border-radius: 10px;
  padding: 10px 13px;
  min-width: 150px;
  pointer-events: none;
  opacity: 0;
  transform: translateY(4px) scale(0.97);
  transition: opacity 0.15s, transform 0.15s;
  z-index: 10;
  box-shadow: 0 8px 24px rgba(7,48,86,.25);
}
.wt-tooltip::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: var(--ph-primary);
  border-bottom: none;
}
.wt-tooltip-date   { font-size: 10px; opacity: 0.65; margin-bottom: 3px; font-weight: 500; }
.wt-tooltip-weight { font-size: 20px; font-weight: 800; line-height: 1; }
.wt-tooltip-note   { font-size: 11px; opacity: 0.75; margin-top: 4px; font-style: italic; }
.wt-tooltip-delta  { font-size: 11px; margin-top: 4px; font-weight: 600; }

/* ── Suggestion ── */
.wt-suggestion {
  font-size: 12.5px;
  line-height: 1.5;
  padding: 10px 13px;
  border-radius: 10px;
  border-left: 3px solid currentColor;
}
.wt-suggestion--ok   { background: rgba(34,197,94,.07);  color: #166534; border-left-color: var(--ph-success); }
.wt-suggestion--warn { background: rgba(232,28,8,.07);   color: #991b1b; border-left-color: var(--ph-danger); }

/* ── Empty ── */
.wt-empty {
  text-align: center;
  padding: 40px 20px;
}
.wt-empty-icon  { font-size: 36px; margin-bottom: 12px; }
.wt-empty-title { font-size: 15px; font-weight: 700; color: var(--ph-text); margin-bottom: 4px; }
.wt-empty-sub   { font-size: 13px; color: var(--ph-muted); }

/* ── History ── */
.wt-history {
  border-top: 1px solid var(--ph-border);
  padding: 16px;
}
.wt-history-title {
  font-size: 11px; font-weight: 700; color: var(--ph-muted);
  text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 12px;
}

.wt-hist-list { display: flex; flex-direction: column; gap: 0; }

.wt-hist-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--ph-border);
  position: relative;
}
.wt-hist-item:last-child { border-bottom: none; }

.wt-hist-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: var(--ph-primary);
  flex-shrink: 0;
  margin-top: 5px;
  opacity: 0.5;
}
.wt-hist-item:first-child .wt-hist-dot { opacity: 1; }

.wt-hist-body { flex: 1; min-width: 0; }
.wt-hist-top  { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }

.wt-hist-w    { font-size: 15px; font-weight: 700; color: var(--ph-text); }
.wt-hist-date { font-size: 12px; color: var(--ph-muted); margin-left: auto; }
.wt-hist-note { font-size: 12px; color: var(--ph-muted); margin-top: 2px; font-style: italic; }

.wt-hist-delta {
  font-size: 11px; font-weight: 600;
  padding: 1px 7px; border-radius: 20px;
}
.wt-hist-delta--up   { background: rgba(232,28,8,.1);  color: var(--ph-danger); }
.wt-hist-delta--down { background: rgba(34,197,94,.1); color: var(--ph-success); }

.wt-del {
  background: none; border: none; cursor: pointer;
  color: var(--ph-muted); padding: 4px; border-radius: 6px;
  opacity: 0; transition: opacity 0.15s, color 0.15s, background 0.15s;
  flex-shrink: 0; line-height: 1;
}
.wt-hist-item:hover .wt-del { opacity: 1; }
.wt-del:hover { color: var(--ph-danger); background: rgba(232,28,8,.08); }

/* ── Pet Selector ── */
.ph-pet-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: var(--ph-surface);
  border-bottom: 1px solid var(--ph-border);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.ph-pet-selector::-webkit-scrollbar { display: none; }

.ph-pet-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--ph-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.ph-pet-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px 5px 5px;
  background: var(--ph-bg);
  border: 1.5px solid var(--ph-border);
  border-radius: 100px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--ph-muted);
  white-space: nowrap;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
  flex-shrink: 0;
}
.ph-pet-pill:hover { border-color: var(--ph-primary); color: var(--ph-primary); }
.ph-pet-pill--active {
  background: var(--ph-primary);
  border-color: var(--ph-primary);
  color: #fff;
}

.ph-pet-av {
  width: 22px; height: 22px;
  border-radius: 50%;
  background: rgba(7,48,86,.1);
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 700;
  overflow: hidden; flex-shrink: 0;
}
.ph-pet-pill--active .ph-pet-av { background: rgba(255,255,255,.2); }
.ph-pet-av img { width: 100%; height: 100%; object-fit: cover; }

/* ── Medical stub ── */
.ph-med-empty {
  text-align: center; padding: 48px 24px;
}
.ph-med-empty-icon  { font-size: 40px; margin-bottom: 14px; }
.ph-med-empty-title { font-size: 15px; font-weight: 700; color: var(--ph-text); margin-bottom: 6px; }
.ph-med-empty-desc  { font-size: 13px; color: var(--ph-muted); line-height: 1.6; max-width: 280px; margin: 0 auto; }

/* ── Ideal weight badge ── */
.wt-ideal {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 11px;
  border-radius: 10px;
  flex-shrink: 0;
  gap: 2px;
}
.wt-ideal-val { font-size: 13px; font-weight: 800; }
.wt-ideal-lbl { font-size: 9px; font-weight: 500; white-space: nowrap; opacity: 0.8; }
.wt-ideal--ok    { background: rgba(34,197,94,.1);  color: #166534; }
.wt-ideal--over  { background: rgba(232,28,8,.08);  color: var(--ph-danger); }
.wt-ideal--under { background: rgba(244,183,0,.12); color: #92400e; }

/* suggestion hint (secondary text) */
.wt-suggestion-hint { font-size: 11px; opacity: 0.75; }

/* ── Single entry hint ── */
.wt-stat-first {
  flex: 1;
  font-size: 12px;
  color: var(--ph-muted);
  line-height: 1.5;
  padding: 4px 0;
}

/* ── Loading ── */
.wt-loading {
  display: flex; justify-content: center; align-items: center;
  padding: 40px;
}
.wt-spinner {
  width: 28px; height: 28px;
  border: 2.5px solid var(--ph-border);
  border-top-color: var(--ph-primary);
  border-radius: 50%;
  animation: wt-spin 0.7s linear infinite;
}
@keyframes wt-spin { to { transform: rotate(360deg); } }

/* ── Error ── */
.wt-error {
  margin: 12px 16px;
  padding: 10px 14px;
  background: rgba(232,28,8,.08);
  color: var(--ph-danger);
  border-radius: 8px;
  font-size: 13px;
}

@media (max-width: 420px) {
  .wt-form-inner { flex-wrap: wrap; }
  .wt-input-wrap { flex: 0 0 80px; }
  .wt-input-note { flex: 1 1 100%; order: 3; }
  .wt-add-btn    { order: 2; }
  .wt-stats      { flex-wrap: wrap; }
  .wt-delta      { margin-left: 0; }
}

/* ══════════════════════════════════════════════
   DIAGNOSTICS
══════════════════════════════════════════════ */
.ph-diag-root { padding: 16px; display: flex; flex-direction: column; gap: 18px; }
.ph-diag-section-label { font-size: 10.5px; font-weight: 700; color: var(--ph-muted); text-transform: uppercase; letter-spacing: 0.45px; margin-bottom: 8px; }
.ph-diag-tags { display: flex; flex-wrap: wrap; gap: 6px; min-height: 28px; }
.ph-diag-tag { display: inline-flex; align-items: center; gap: 5px; padding: 5px 10px 5px 12px; background: var(--ph-primary); color: #fff; border-radius: 20px; font-size: 12px; font-weight: 600; }
.ph-diag-tag-rm { background: none; border: none; color: rgba(255,255,255,.65); cursor: pointer; font-size: 16px; padding: 0 0 0 2px; line-height: 1; display: flex; align-items: center; }
.ph-diag-tag-rm:hover { color: #fff; }
.ph-diag-none { font-size: 13px; color: var(--ph-muted); padding: 4px 0; }
.ph-diag-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.ph-diag-chip { display: inline-flex; align-items: center; padding: 5px 11px; background: var(--ph-surface2); border: 1.5px solid var(--ph-border); border-radius: 20px; font-size: 12px; font-weight: 500; cursor: pointer; color: var(--ph-text); transition: border-color .15s, color .15s, background .15s; }
.ph-diag-chip:hover:not([disabled]) { border-color: var(--ph-primary); color: var(--ph-primary); background: rgba(7,48,86,.05); }
.ph-diag-chip[disabled] { opacity: .38; cursor: default; }
.ph-diag-custom-row { display: flex; gap: 8px; }
.ph-diag-custom-in { flex: 1; padding: 9px 12px; border: 1.5px solid var(--ph-border); border-radius: 9px; font-size: 13px; font-family: inherit; color: var(--ph-text); background: var(--ph-bg); outline: none; transition: border-color .15s; }
.ph-diag-custom-in:focus { border-color: var(--ph-primary); }
.ph-diag-custom-btn { padding: 9px 14px; background: var(--ph-primary); color: #fff; border: none; border-radius: 9px; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; transition: opacity .15s; }
.ph-diag-custom-btn:hover { opacity: .85; }
`;

  // Security note: innerHTML used inside Shadow DOM only.
  // All user values pass through _esc(). Numerics validated server-side.

  class WeightTracker {
    constructor({ apiBase, petId, authHeaders, onError, idealWeight = null }) {
      this.apiBase      = apiBase.replace(/\/$/, "");
      this.petId        = petId;
      this.authHeaders  = authHeaders;
      this.onError      = onError || (() => {});
      this.idealWeight  = idealWeight ? parseFloat(idealWeight) : null;
      this.entries      = [];
      this.loading      = false;
      this._container   = null;
      this._gradId      = "wg" + Math.random().toString(36).slice(2, 7);
    }

    // ── Render ─────────────────────────────────────────────────────────────────

    render(container) {
      this._container = container;

      if (this.loading) {
        container.innerHTML = `<div class="wt-loading"><div class="wt-spinner"></div></div>`;
        return;
      }

      const entries = [...this.entries].sort((a, b) => b.recorded_at - a.recorded_at);

      container.innerHTML = `
      <div class="wt-root">
        ${this._renderForm()}
        ${this._renderChartShell(entries)}
        ${this._renderHistory(entries)}
      </div>`;

      this._bindForm(container);

      if (entries.length > 0) {
        this._buildChart(container, entries);
      }
    }

    // ── Form ───────────────────────────────────────────────────────────────────

    _renderForm() {
      return `
      <div class="wt-form">
        <div class="wt-form-inner">
          <div class="wt-input-wrap">
            <span class="wt-input-unit">kg</span>
            <input class="wt-input wt-input-kg" id="wt-kg" type="number"
              inputmode="decimal" step="0.1" min="0.5" max="300" placeholder="0.0">
          </div>
          <input class="wt-input wt-input-note" id="wt-note" type="text"
            placeholder="Notă (opțional)" maxlength="200">
          <button class="wt-add-btn" id="wt-add">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
            </svg>
            Adaugă
          </button>
        </div>
      </div>`;
    }

    // ── Chart shell (HTML skeleton — SVG built separately via JS) ───────────────

    _renderChartShell(entries) {
      const asc = [...entries].sort((a, b) => a.recorded_at - b.recorded_at);

      if (!entries.length) {
        return `
        <div class="wt-chart-shell">
          <div class="wt-empty">
            <div class="wt-empty-icon">⚖️</div>
            <div class="wt-empty-title">Nicio înregistrare</div>
            <div class="wt-empty-sub">Adaugă prima greutate pentru a vedea evoluția</div>
          </div>
        </div>`;
      }

      const weights = asc.map(e => parseFloat(e.weight_kg));
      const latest  = weights[weights.length - 1];
      const first   = weights[0];
      const minW    = Math.min(...weights);
      const maxW    = Math.max(...weights);
      const avg     = weights.reduce((s, w) => s + w, 0) / weights.length;
      const delta   = latest - first;
      const deltaStr = (delta >= 0 ? "+" : "") + delta.toFixed(1) + " kg";
      const deltaCls = delta > 1 ? "wt-delta--up" : delta < -1 ? "wt-delta--down" : "wt-delta--stable";

      // Ideal weight badge — shown when ideal weight is set in pet profile
      const idealBadge = this.idealWeight ? (() => {
        const diff = latest - this.idealWeight;
        const cls  = Math.abs(diff) <= 0.5 ? "wt-ideal--ok" : diff > 0 ? "wt-ideal--over" : "wt-ideal--under";
        const sign = diff > 0 ? "+" : "";
        const label = Math.abs(diff) <= 0.5 ? "optimal" : sign + diff.toFixed(1) + " kg";
        return `<div class="wt-ideal ${cls}">
        <span class="wt-ideal-val">🎯 ${this.idealWeight} kg</span>
        <span class="wt-ideal-lbl">ideal · ${label}</span>
      </div>`;
      })() : "";

      const statsExtra = entries.length > 1 ? `
      <div class="wt-stat-group">
        <div class="wt-stat wt-stat--sm">
          <span class="wt-stat-num">${minW.toFixed(1)}</span>
          <span class="wt-stat-lbl">Min</span>
        </div>
        <div class="wt-stat wt-stat--sm">
          <span class="wt-stat-num">${maxW.toFixed(1)}</span>
          <span class="wt-stat-lbl">Max</span>
        </div>
        <div class="wt-stat wt-stat--sm">
          <span class="wt-stat-num">${avg.toFixed(1)}</span>
          <span class="wt-stat-lbl">Medie</span>
        </div>
      </div>
      ${idealBadge || `<div class="wt-delta ${deltaCls}">
        <span class="wt-delta-val">${deltaStr}</span>
        <span class="wt-delta-lbl">față de start</span>
      </div>`}` : `
      ${idealBadge || `<div class="wt-stat-first">Prima înregistrare.<br>Adaugă mai multe pentru a vedea evoluția.</div>`}`;

      return `
      <div class="wt-chart-shell">
        <div class="wt-stats">
          <div class="wt-stat wt-stat--hero">
            <div class="wt-stat--hero-row">
              <span class="wt-stat-num">${latest.toFixed(1)}</span>
              <span class="wt-stat-unit">kg</span>
            </div>
            <span class="wt-stat-lbl">Acum</span>
          </div>
          ${statsExtra}
        </div>

        <div class="wt-chart-wrap" id="wt-chart-wrap">
          <div id="wt-svg-slot"></div>
          <div class="wt-tooltip" id="wt-tooltip" aria-hidden="true">
            <div class="wt-tooltip-date"   id="wt-tt-date"></div>
            <div class="wt-tooltip-weight" id="wt-tt-weight"></div>
            <div class="wt-tooltip-note"   id="wt-tt-note"></div>
            <div class="wt-tooltip-delta"  id="wt-tt-delta"></div>
          </div>
        </div>

        ${this._renderSuggestion(asc)}
      </div>`;
    }

    // ── SVG built at runtime (correct pixel dimensions → no oval dots) ──────────

    _buildChart(container, entries) {
      const slot    = container.querySelector("#wt-svg-slot");
      const wrap    = container.querySelector("#wt-chart-wrap");
      const tooltip = container.querySelector("#wt-tooltip");
      if (!slot || !wrap) return;

      const asc = [...entries].sort((a, b) => a.recorded_at - b.recorded_at);

      const build = () => {
        // Use actual pixel width so viewBox 1:1 → no scaling distortion on dots
        const W = Math.max(220, slot.getBoundingClientRect().width);
        const H = 190;
        slot.innerHTML = this._buildSVGMarkup(asc, W, H);
        const svg = slot.querySelector("svg");
        if (svg && tooltip) this._bindTooltip(wrap, svg, tooltip, asc);
      };

      requestAnimationFrame(build);
    }

    _buildSVGMarkup(asc, W, H) {
      const n  = asc.length;
      const PL = 30, PR = 10, PT = 18, PB = 28;
      const cW = W - PL - PR;
      const cH = H - PT - PB;

      const weights = asc.map(e => parseFloat(e.weight_kg));
      let minW = Math.min(...weights), maxW = Math.max(...weights);
      if (maxW - minW < 1.5) { minW -= 1; maxW += 1; }
      const wRange = maxW - minW;

      const toX = i => PL + (n === 1 ? cW / 2 : (i / (n - 1)) * cW);
      const toY = w => PT + (1 - (w - minW) / wRange) * cH;

      const pts = asc.map((e, i) => ({
        x: toX(i), y: toY(parseFloat(e.weight_kg)),
        w: parseFloat(e.weight_kg), e,
      }));

      // Smooth cubic bezier
      const pathD = pts.map((p, i) => {
        if (i === 0) return `M${p.x.toFixed(1)},${p.y.toFixed(1)}`;
        const prev = pts[i - 1];
        const cpX  = (prev.x + p.x) / 2;
        return `C${cpX.toFixed(1)},${prev.y.toFixed(1)} ${cpX.toFixed(1)},${p.y.toFixed(1)} ${p.x.toFixed(1)},${p.y.toFixed(1)}`;
      }).join(" ");

      const areaD = `${pathD} L${pts[n-1].x.toFixed(1)},${(PT+cH).toFixed(1)} L${pts[0].x.toFixed(1)},${(PT+cH).toFixed(1)} Z`;

      // Horizontal grid lines
      const grids = [0, 0.5, 1].map(t => {
        const y = toY(minW + t * wRange).toFixed(1);
        return `<line x1="${PL}" y1="${y}" x2="${(W-PR).toFixed(1)}" y2="${y}" stroke="var(--ph-border)" stroke-width="1"/>`;
      }).join("");

      // Y labels
      const yLabels = [0, 0.5, 1].map(t => {
        const w = minW + t * wRange;
        const y = toY(w).toFixed(1);
        return `<text class="wt-axis-lbl" x="2" y="${y}" dominant-baseline="middle">${w.toFixed(0)}</text>`;
      }).join("");

      // X labels (smart — show first, middle, last)
      const xLabels = pts.map((p, i) => {
        const show = n <= 3 ? true : (i === 0 || i === n - 1 || i === Math.round((n - 1) / 2));
        if (!show) return "";
        const d = new Date(p.e.recorded_at * 1000);
        const lbl = `${d.getDate()}.${String(d.getMonth()+1).padStart(2,"0")}.${String(d.getFullYear()).slice(2)}`;
        const anchor = i === 0 ? "start" : i === n - 1 ? "end" : "middle";
        return `<text class="wt-axis-lbl wt-axis-lbl--x" x="${p.x.toFixed(1)}" y="${(H-6).toFixed(1)}" text-anchor="${anchor}">${lbl}</text>`;
      }).join("");

      // Dots
      const dots = pts.map((p, i) => {
        const isLast = i === n - 1;
        const r = isLast ? 6 : 5;
        return `<g class="wt-dot-g" data-idx="${i}" style="cursor:pointer">
        ${isLast ? `<circle class="wt-pulse" cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="8"/>` : ""}
        <circle class="wt-dot ${isLast ? "wt-dot--last" : ""}" cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="${r}"/>
        <circle fill="transparent" cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="22" style="cursor:pointer"/>
      </g>`;
      }).join("");

      // Store pts for tooltip use
      const ptsData = JSON.stringify(pts.map(p => ({ x: p.x, y: p.y, w: p.w, e: p.e })));

      return `
<svg class="wt-svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" id="wt-svg" data-pts='${ptsData}'>
  <defs>
    <linearGradient id="${this._gradId}-line" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%"   stop-color="var(--ph-accent)"/>
      <stop offset="100%" stop-color="var(--ph-primary)"/>
    </linearGradient>
    <linearGradient id="${this._gradId}-area" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%"   stop-color="var(--ph-primary)" stop-opacity="0.14"/>
      <stop offset="100%" stop-color="var(--ph-primary)" stop-opacity="0.01"/>
    </linearGradient>
    <style>
      .wt-line { stroke-dasharray: 4000; stroke-dashoffset: 4000;
        animation: wt-draw 1.2s cubic-bezier(.4,0,.2,1) forwards 0.1s; }
      @keyframes wt-draw { to { stroke-dashoffset: 0; } }
      .wt-area { opacity: 0; animation: wt-fade 0.7s ease forwards 1s; }
      @keyframes wt-fade { to { opacity: 1; } }
      .wt-dot { fill: var(--ph-bg); stroke: var(--ph-primary); stroke-width: 2.5;
        transition: fill 0.15s; }
      .wt-dot--last { fill: var(--ph-primary); }
      .wt-dot-g:hover .wt-dot, .wt-dot-g:active .wt-dot { fill: var(--ph-primary); }
      .wt-pulse { fill: none; stroke: var(--ph-primary); stroke-width: 1.5; opacity: 0;
        animation: wt-pulse 2s ease-out infinite 1.3s; }
      @keyframes wt-pulse { 0%{r:7;opacity:.55} 100%{r:22;opacity:0} }
      .wt-axis-lbl { font-size: 10px; fill: var(--ph-muted); font-family: inherit; }
    </style>
  </defs>
  ${grids}
  <path class="wt-area" d="${areaD}" fill="url(#${this._gradId}-area)"/>
  <path class="wt-line" d="${pathD}" fill="none"
    stroke="url(#${this._gradId}-line)" stroke-width="2.5"
    stroke-linecap="round" stroke-linejoin="round"/>
  ${yLabels}
  ${dots}
  ${xLabels}
</svg>`;
    }

    // ── Tooltip ─────────────────────────────────────────────────────────────────

    _bindTooltip(wrap, svg, tooltip, asc) {
      const ttDate  = tooltip.querySelector("#wt-tt-date");
      const ttW     = tooltip.querySelector("#wt-tt-weight");
      const ttNote  = tooltip.querySelector("#wt-tt-note");
      const ttDelta = tooltip.querySelector("#wt-tt-delta");

      const showTT = (idx, cx, cy) => {
        const e    = asc[idx];
        const prev = asc[idx - 1];
        const d    = new Date(e.recorded_at * 1000);

        ttDate.textContent = d.toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" });
        ttW.textContent    = parseFloat(e.weight_kg).toFixed(1) + " kg";
        ttNote.textContent = e.note || "";
        ttNote.style.display = e.note ? "block" : "none";

        if (prev) {
          const diff = parseFloat(e.weight_kg) - parseFloat(prev.weight_kg);
          ttDelta.textContent = (diff >= 0 ? "+" : "") + diff.toFixed(1) + " kg față de anterior";
          ttDelta.style.display = "block";
          ttDelta.style.color = diff > 0 ? "var(--ph-danger)" : diff < 0 ? "var(--ph-success)" : "var(--ph-muted)";
        } else {
          ttDelta.style.display = "none";
        }

        // cx/cy are already in real pixels (viewBox = actual px → 1:1)
        const wrapRect = wrap.getBoundingClientRect();
        const slotRect = svg.parentElement.getBoundingClientRect();
        const px = slotRect.left - wrapRect.left + cx;
        const py = slotRect.top  - wrapRect.top  + cy;

        const ttW2 = 165;
        let left = Math.max(4, Math.min(px - ttW2 / 2, wrapRect.width - ttW2 - 4));
        let top  = py - 112;
        if (top < 4) top = py + 20;

        tooltip.style.left      = left + "px";
        tooltip.style.top       = top  + "px";
        tooltip.style.opacity   = "1";
        tooltip.style.transform = "translateY(0) scale(1)";
      };

      const hideTT = () => {
        tooltip.style.opacity   = "0";
        tooltip.style.transform = "translateY(4px) scale(0.97)";
      };

      svg.querySelectorAll(".wt-dot-g").forEach((g, i) => {
        const dot = g.querySelector(".wt-dot");
        const cx  = parseFloat(dot.getAttribute("cx"));
        const cy  = parseFloat(dot.getAttribute("cy"));
        g.addEventListener("mouseenter", () => showTT(i, cx, cy));
        g.addEventListener("touchstart", (ev) => { ev.preventDefault(); showTT(i, cx, cy); }, { passive: false });
        g.addEventListener("mouseleave", hideTT);
        g.addEventListener("touchend", () => setTimeout(hideTT, 1800));
      });

      wrap.addEventListener("mouseleave", hideTT);
    }

    // ── Suggestion ─────────────────────────────────────────────────────────────

    _renderSuggestion(asc) {
      if (!asc.length) return "";
      const latest = parseFloat(asc[asc.length - 1].weight_kg);

      // ── Ideal-weight-aware logic (priority) ──────────────────────────────
      if (this.idealWeight) {
        const diff    = latest - this.idealWeight;
        const absDiff = Math.abs(diff);

        if (absDiff <= 0.5) {
          return `<div class="wt-suggestion wt-suggestion--ok">✅ Greutate optimă! ${latest.toFixed(1)} kg corespunde greutății ideale setate pentru câinele tău.</div>`;
        }
        if (diff > 0) {
          // Over ideal weight
          if (diff <= 1.5) {
            return `<div class="wt-suggestion wt-suggestion--ok">📈 <strong>+${diff.toFixed(1)} kg</strong> față de greutatea ideală (${this.idealWeight} kg). Mică depășire — monitorizează porțiile și activitatea.</div>`;
          }
          if (diff <= 3) {
            return `<div class="wt-suggestion wt-suggestion--warn">⚠️ <strong>+${diff.toFixed(1)} kg</strong> față de greutatea ideală (${this.idealWeight} kg). Consideră reducerea porțiilor sau trecerea la o rețetă cu mai puține calorii (ex. DARF Light).</div>`;
          }
          return `<div class="wt-suggestion wt-suggestion--warn">⚠️ <strong>+${diff.toFixed(1)} kg</strong> față de greutatea ideală (${this.idealWeight} kg). Suprapondere semnificativă — consultă veterinarul pentru un plan de slăbire.</div>`;
        }

        // Under ideal weight
        if (absDiff <= 1.5) {
          return `<div class="wt-suggestion wt-suggestion--ok">📉 <strong>${diff.toFixed(1)} kg</strong> față de greutatea ideală (${this.idealWeight} kg). Ușor sub ideal — urmărește evoluția.</div>`;
        }
        if (absDiff <= 3) {
          return `<div class="wt-suggestion wt-suggestion--warn">⚠️ <strong>${diff.toFixed(1)} kg</strong> față de greutatea ideală (${this.idealWeight} kg). Câinele este sub greutatea ideală — verifică alimentația și porțiile.</div>`;
        }
        return `<div class="wt-suggestion wt-suggestion--warn">⚠️ <strong>${diff.toFixed(1)} kg</strong> față de greutatea ideală (${this.idealWeight} kg). Subpondere semnificativă — consultă veterinarul.</div>`;
      }

      // ── Fallback: no ideal weight set ────────────────────────────────────
      if (asc.length < 2) {
        return `<div class="wt-suggestion wt-suggestion--ok">💡 Setează <strong>greutatea ideală</strong> în <em>Câinii mei → Editează</em> pentru sugestii personalizate bazate pe obiectivul câinelui tău.</div>`;
      }

      // Delta-based fallback (generic, without ideal weight context)
      const prev = parseFloat(asc[asc.length - 2].weight_kg);
      const diff = latest - prev;
      if (Math.abs(diff) < 0.2) {
        return `<div class="wt-suggestion wt-suggestion--ok">✅ Greutate stabilă. <span class="wt-suggestion-hint">Setează greutatea ideală în profil pentru sugestii precise.</span></div>`;
      }
      if (diff > 0) {
        return `<div class="wt-suggestion ${diff > 1.5 ? "wt-suggestion--warn" : "wt-suggestion--ok"}">${diff > 1.5 ? "⚠️" : "📈"} <strong>+${diff.toFixed(1)} kg</strong> față de ultima înregistrare. <span class="wt-suggestion-hint">Setează greutatea ideală în profil pentru context precis.</span></div>`;
      }
      return `<div class="wt-suggestion ${Math.abs(diff) > 1.5 ? "wt-suggestion--warn" : "wt-suggestion--ok"}">${Math.abs(diff) > 1.5 ? "⚠️" : "📉"} <strong>${diff.toFixed(1)} kg</strong> față de ultima înregistrare. <span class="wt-suggestion-hint">Setează greutatea ideală în profil pentru context precis.</span></div>`;
    }

    // ── History ────────────────────────────────────────────────────────────────

    _renderHistory(entries) {
      if (!entries.length) return "";
      const items = entries.map((e, i) => {
        const prev  = entries[i + 1];
        const delta = prev ? (parseFloat(e.weight_kg) - parseFloat(prev.weight_kg)) : null;
        const deltaHTML = delta !== null
          ? `<span class="wt-hist-delta ${delta > 0 ? "wt-hist-delta--up" : delta < 0 ? "wt-hist-delta--down" : ""}">${delta > 0 ? "+" : ""}${delta.toFixed(1)}</span>`
          : "";
        const note = e.note ? `<div class="wt-hist-note">${this._esc(String(e.note))}</div>` : "";
        return `<div class="wt-hist-item">
        <div class="wt-hist-dot"></div>
        <div class="wt-hist-body">
          <div class="wt-hist-top">
            <span class="wt-hist-w">${parseFloat(e.weight_kg).toFixed(1)} kg</span>
            ${deltaHTML}
            <span class="wt-hist-date">${this._fmtDate(e.recorded_at)}</span>
          </div>
          ${note}
        </div>
        <button class="wt-del" data-id="${e.id}" title="Șterge">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 2l8 8M10 2L2 10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </button>
      </div>`;
      }).join("");

      return `<div class="wt-history">
      <div class="wt-history-title">Istoric</div>
      <div class="wt-hist-list">${items}</div>
    </div>`;
    }

    // ── Events ─────────────────────────────────────────────────────────────────

    _bindForm(container) {
      const addBtn = container.querySelector("#wt-add");
      if (!addBtn) return;
      addBtn.addEventListener("click", () => {
        const kg   = parseFloat(container.querySelector("#wt-kg").value);
        const note = (container.querySelector("#wt-note").value || "").trim();
        if (!kg || kg <= 0) { this.onError("Introdu o greutate validă"); return; }
        this.addEntry(kg, note);
      });
      container.querySelectorAll(".wt-del").forEach(btn => {
        btn.addEventListener("click", () => { if (btn.dataset.id) this.deleteEntry(btn.dataset.id); });
      });
    }

    // ── API ────────────────────────────────────────────────────────────────────

    async fetchEntries() {
      this.loading = true;
      if (this._container) this.render(this._container);
      try {
        const r = await fetch(`${this.apiBase}/health/weight/${this.petId}`, { headers: this.authHeaders() });
        const d = await r.json();
        if (d.ok) this.entries = d.entries || [];
        else this.onError(d.error || "Eroare la încărcarea datelor");
      } catch { this.onError("Eroare de rețea."); }
      this.loading = false;
      if (this._container) this.render(this._container);
    }

    async addEntry(weight_kg, note) {
      try {
        const r = await fetch(`${this.apiBase}/health/weight/${this.petId}`, {
          method: "POST",
          headers: { "content-type": "application/json", ...this.authHeaders() },
          body: JSON.stringify({ weight_kg, note }),
        });
        const d = await r.json();
        if (d.ok) await this.fetchEntries();
        else this.onError(d.error || "Eroare la adăugare");
      } catch { this.onError("Eroare de rețea."); }
    }

    async deleteEntry(id) {
      try {
        const r = await fetch(`${this.apiBase}/health/weight/${this.petId}/${id}`, {
          method: "DELETE", headers: this.authHeaders(),
        });
        const d = await r.json();
        if (d.ok) await this.fetchEntries();
        else this.onError(d.error || "Eroare la ștergere");
      } catch { this.onError("Eroare de rețea."); }
    }

    _fmtDate(ts) {
      return new Date(ts * 1000).toLocaleDateString("ro-RO", { day: "numeric", month: "short", year: "numeric" });
    }

    _esc(s) {
      return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;");
    }
  }

  // Medical Profile component — stub for Phase 2
  // Will include: medication list, add/edit/stop medications,
  // and drug-product interaction warnings via AI analysis.
  // Note: innerHTML below contains only static strings from our code — no user input.

  const PREDEFINED_CONDITIONS = [
    { id: "pancreatita",   label: "Pancreatit\u0103" },
    { id: "boala_renala",  label: "Boal\u0103 renal\u0103" },
    { id: "diabet",        label: "Diabet" },
    { id: "epilepsie",     label: "Epilepsie" },
    { id: "hipotiroidism", label: "Hipotiroidism" },
    { id: "boli_cardiace", label: "Boli cardiace" },
    { id: "IBD",           label: "IBD / Colon iritabil" },
    { id: "artrita",       label: "Artrit\u0103" },
    { id: "displazie",     label: "Displazie \u015fold/cot" },
    { id: "alergii_piele", label: "Alergii cutanate" },
    { id: "cushing",       label: "Sindrom Cushing" },
    { id: "litiaza",       label: "Litia\u021B\u0103 urinar\u0103" },
    { id: "tumori",        label: "Neoplasm / Tumor\u0103" },
  ];

  class DiagnosticsProfile {
    constructor({ apiBase, petId, authHeaders, onError }) {
      this.apiBase     = apiBase.replace(/\/$/, "");
      this.petId       = petId;
      this.authHeaders = authHeaders;
      this.onError     = onError || (() => {});
      this._container  = null;
      this._conditions = [];
    }

    async render(container) {
      this._container = container;
      container.textContent = "";
      const loading = document.createElement("div");
      loading.style.cssText = "padding:24px 16px;text-align:center;color:var(--ph-muted);font-size:13px";
      loading.textContent = "Se \u00EEncarc\u0103\u2026";
      container.appendChild(loading);
      try {
        const r = await fetch(this.apiBase + "/health/conditions/" + this.petId, { headers: this.authHeaders() });
        const d = await r.json();
        this._conditions = d.conditions || [];
      } catch (e) {
        this._conditions = [];
      }
      this._render();
    }

    _render() {
      const c = this._container;
      if (!c) return;
      const existingIds = new Set(this._conditions.map(x => x.condition_id));
      c.textContent = "";
      const root = document.createElement("div");
      root.className = "ph-diag-root";

      // Active conditions
      const secActive = document.createElement("div");
      const lblActive = document.createElement("div");
      lblActive.className = "ph-diag-section-label";
      lblActive.textContent = "Diagnostice active";
      secActive.appendChild(lblActive);
      const tagsDiv = document.createElement("div");
      tagsDiv.className = "ph-diag-tags";
      if (this._conditions.length === 0) {
        const none = document.createElement("div");
        none.className = "ph-diag-none";
        none.textContent = "Nicio afec\u021Biune \u00EEnregistrat\u0103";
        tagsDiv.appendChild(none);
      } else {
        this._conditions.forEach(cond => tagsDiv.appendChild(this._buildTag(cond)));
      }
      secActive.appendChild(tagsDiv);
      root.appendChild(secActive);

      // Predefined chips
      const secPick = document.createElement("div");
      const lblPick = document.createElement("div");
      lblPick.className = "ph-diag-section-label";
      lblPick.textContent = "Adaug\u0103 afec\u021Biune";
      secPick.appendChild(lblPick);
      const chipsDiv = document.createElement("div");
      chipsDiv.className = "ph-diag-chips";
      PREDEFINED_CONDITIONS.forEach(cond => {
        const chip = document.createElement("button");
        chip.type = "button";
        chip.className = "ph-diag-chip";
        chip.textContent = cond.label;
        chip.dataset.condId = cond.id;
        if (existingIds.has(cond.id)) {
          chip.setAttribute("disabled", "");
          chip.title = "Deja ad\u0103ugat";
        } else {
          chip.addEventListener("click", () => {
            chip.disabled = true;
            chip.style.opacity = "0.5";
            this._add(cond.id, cond.label);
          });
        }
        chipsDiv.appendChild(chip);
      });
      secPick.appendChild(chipsDiv);
      root.appendChild(secPick);

      // Custom condition
      const secCustom = document.createElement("div");
      const lblCustom = document.createElement("div");
      lblCustom.className = "ph-diag-section-label";
      lblCustom.textContent = "Alt\u0103 afec\u021Biune";
      secCustom.appendChild(lblCustom);
      const customRow = document.createElement("div");
      customRow.className = "ph-diag-custom-row";
      const customIn = document.createElement("input");
      customIn.className = "ph-diag-custom-in";
      customIn.placeholder = "ex. Cataract\u0103, Hipersaliva\u021Bie\u2026";
      customIn.maxLength = 80;
      const customBtn = document.createElement("button");
      customBtn.className = "ph-diag-custom-btn";
      customBtn.textContent = "+ Adaug\u0103";
      const doAdd = () => {
        const val = customIn.value.trim();
        if (!val) return;
        const cid = "custom_" + val.toLowerCase().replace(/[^a-z0-9]+/g, "_").slice(0, 40);
        this._add(cid, val);
        customIn.value = "";
      };
      customBtn.addEventListener("click", doAdd);
      customIn.addEventListener("keydown", e => { if (e.key === "Enter") doAdd(); });
      customRow.appendChild(customIn);
      customRow.appendChild(customBtn);
      secCustom.appendChild(customRow);
      root.appendChild(secCustom);

      c.appendChild(root);
    }

    _buildTag(cond) {
      const tag = document.createElement("div");
      tag.className = "ph-diag-tag";
      const lbl = document.createElement("span");
      lbl.textContent = cond.label;
      tag.appendChild(lbl);
      const rm = document.createElement("button");
      rm.className = "ph-diag-tag-rm";
      rm.title = "Elimin\u0103";
      rm.textContent = "\u2715";
      rm.addEventListener("click", () => this._remove(cond.id));
      tag.appendChild(rm);
      return tag;
    }

    async _add(conditionId, label) {
      try {
        const r = await fetch(this.apiBase + "/health/conditions/" + this.petId, {
          method: "POST",
          headers: Object.assign({ "content-type": "application/json" }, this.authHeaders()),
          body: JSON.stringify({ condition_id: conditionId, label }),
        });
        if (!r.ok) {
          var errBody = {};
          try { errBody = await r.json(); } catch {}
          this.onError((errBody.detail || errBody.error || "Eroare") + " [" + r.status + "]");
          this._render();
          return;
        }
        const d = await r.json();
        if (d.ok) {
          if (!d.duplicate) this._conditions.push({ id: d.id, condition_id: conditionId, label });
        } else {
          this.onError((d.detail || d.error || "Eroare la ad\u0103ugare"));
        }
        this._render();
      } catch (e) { this.onError("Eroare la ad\u0103ugare"); this._render(); }
    }

    async _remove(recordId) {
      try {
        const r = await fetch(this.apiBase + "/health/conditions/" + this.petId + "/" + recordId, {
          method: "DELETE", headers: this.authHeaders(),
        });
        const d = await r.json();
        if (d.ok) {
          this._conditions = this._conditions.filter(c => c.id !== recordId);
          this._render();
        }
      } catch (e) { this.onError("Eroare la \u015Ftergere"); }
    }
  }

  class MedicalProfile {
    constructor({ apiBase, petId, authHeaders, onError }) {
      this.apiBase     = apiBase.replace(/\/$/, "");
      this.petId       = petId;
      this.authHeaders = authHeaders;
      this.onError     = onError || (() => {});
      this._container  = null;
    }

    render(container) {
      this._container = container;

      // Static-only content — no user data rendered here
      const panel = document.createElement("div");

      const empty = document.createElement("div");
      empty.className = "ph-med-empty";

      const icon = document.createElement("div");
      icon.className = "ph-med-empty-icon";
      icon.textContent = "💊";

      const title = document.createElement("div");
      title.className = "ph-med-empty-title";
      title.textContent = "Profil medical — în curând";

      const desc = document.createElement("div");
      desc.className = "ph-med-empty-desc";
      desc.textContent = "Vei putea adăuga medicamentele câinelui tău și vei primi avertizări automate pe produsele care pot interacționa cu tratamentul.";

      empty.appendChild(icon);
      empty.appendChild(title);
      empty.appendChild(desc);
      panel.appendChild(empty);

      container.innerHTML = "";
      container.appendChild(panel);
    }
  }

  class PetHealth {
    constructor({ container, apiBase, token, petId, pets = null, theme = {} }) {
      if (!container) throw new Error("PetHealth: container is required");
      if (!apiBase)   throw new Error("PetHealth: apiBase is required");

      const el = typeof container === "string"
        ? document.querySelector(container)
        : container;
      if (!el) throw new Error("PetHealth: container not found");

      // Normalize pets — accept either pets[] or single petId
      if (pets && pets.length > 0) {
        this._pets  = pets;
        this._petId = pets[0].id;
      } else if (petId) {
        this._pets  = [{ id: petId, name: "Câine" }];
        this._petId = petId;
      } else {
        throw new Error("PetHealth: petId or pets is required");
      }

      this._apiBase    = apiBase.replace(/\/$/, "");
      this._token      = token;
      this._shadow     = el.attachShadow({ mode: "open" });
      this._medMounted  = false;
      this._diagMounted = false;

      this._applyTheme(theme);
      this._injectStyles();
      this._renderShell();
      this._mountTracker();
    }

    // ── Tracker mount / remount on pet switch ───────────────────────────────

    _mountTracker() {
      const authHeaders = () => this._buildAuthHeaders();

      const activePet = this._pets.find(p => p.id === this._petId) || this._pets[0];
      this._weightTracker = new WeightTracker({
        apiBase: this._apiBase, petId: this._petId, authHeaders,
        idealWeight: activePet ? (activePet.idealWeight || null) : null,
        onError: (msg) => this._showError(msg),
      });

      this._medicalProfile = new MedicalProfile({
        apiBase: this._apiBase, petId: this._petId, authHeaders,
        onError: (msg) => this._showError(msg),
      });

      this._diagProfile = new DiagnosticsProfile({
        apiBase: this._apiBase, petId: this._petId, authHeaders,
        onError: (msg) => this._showError(msg),
      });

      const weightPanel = this._shadow.querySelector("#ph-panel-weight");
      if (weightPanel) {
        this._weightTracker.render(weightPanel);
        this._weightTracker.fetchEntries();
      }
    }

    _switchPet(petId) {
      if (petId === this._petId) return;
      this._petId       = petId;
      this._medMounted  = false;
      this._diagMounted = false;

      const diagPanel = this._shadow.querySelector("#ph-panel-diagnostics");
      if (diagPanel) diagPanel.textContent = "";
      const medPanel = this._shadow.querySelector("#ph-panel-medical");
      if (medPanel) medPanel.textContent = "";

      // Update selector active pills
      this._shadow.querySelectorAll(".ph-pet-pill").forEach(pill => {
        pill.classList.toggle("ph-pet-pill--active", pill.dataset.id === petId);
      });

      this._mountTracker();
    }

    // ── Auth ────────────────────────────────────────────────────────────────

    _buildAuthHeaders() {
      const t = this._token;
      if (!t) return {};
      if (typeof t === "object" && t.token) {
        return {
          "x-customer-id":    String(t.cid   || ""),
          "x-customer-email": String(t.email || ""),
          "x-customer-token": String(t.token || ""),
        };
      }
      if (typeof t === "string") return { "authorization": `Bearer ${t}` };
      return {};
    }

    // ── Theme / styles ──────────────────────────────────────────────────────

    _applyTheme(theme) {
      const MAP = {
        primary: "--ph-primary", accent: "--ph-accent", danger: "--ph-danger",
        bg: "--ph-bg", surface: "--ph-surface", text: "--ph-text",
      };
      const host = this._shadow.host;
      if (host) {
        Object.entries(theme).forEach(([k, v]) => {
          if (MAP[k]) host.style.setProperty(MAP[k], String(v));
        });
      }
    }

    _injectStyles() {
      const style = document.createElement("style");
      style.textContent = STYLES;
      this._shadow.appendChild(style);
    }

    // ── Shell ───────────────────────────────────────────────────────────────

    _renderShell() {
      const wrapper = document.createElement("div");
      wrapper.className = "ph-widget";

      // Pet selector — only when multiple pets
      if (this._pets.length > 1) {
        wrapper.appendChild(this._buildPetSelector());
      }

      // Sub-tabs (Greutate / Diagnostice / Medicamente)
      const tabs = document.createElement("div");
      tabs.className = "ph-tabs";

      const tabWeight = document.createElement("button");
      tabWeight.className = "ph-tab ph-tab--active";
      tabWeight.dataset.tab = "weight";
      tabWeight.textContent = "Greutate";

      const tabDiag = document.createElement("button");
      tabDiag.className = "ph-tab";
      tabDiag.dataset.tab = "diagnostics";
      tabDiag.textContent = "Diagnostice";

      const tabMed = document.createElement("button");
      tabMed.className = "ph-tab";
      tabMed.dataset.tab = "medical";
      tabMed.textContent = "Medicamente";

      tabs.appendChild(tabWeight);
      tabs.appendChild(tabDiag);
      tabs.appendChild(tabMed);

      const panels = document.createElement("div");
      panels.className = "ph-panels";

      const weightPanel = document.createElement("div");
      weightPanel.id = "ph-panel-weight";

      const diagPanel = document.createElement("div");
      diagPanel.id = "ph-panel-diagnostics";
      diagPanel.className = "ph-panel--hidden";

      const medPanel = document.createElement("div");
      medPanel.id = "ph-panel-medical";
      medPanel.className = "ph-panel--hidden";

      panels.appendChild(weightPanel);
      panels.appendChild(diagPanel);
      panels.appendChild(medPanel);
      wrapper.appendChild(tabs);
      wrapper.appendChild(panels);
      this._shadow.appendChild(wrapper);

      this._bindTabs(tabs);
    }

    _buildPetSelector() {
      const sel = document.createElement("div");
      sel.className = "ph-pet-selector";

      const label = document.createElement("span");
      label.className = "ph-pet-label";
      label.textContent = "Câine:";
      sel.appendChild(label);

      this._pets.forEach((pet, i) => {
        const pill = document.createElement("button");
        pill.className = "ph-pet-pill" + (i === 0 ? " ph-pet-pill--active" : "");
        pill.dataset.id = pet.id;

        const av = document.createElement("div");
        av.className = "ph-pet-av";
        if (pet.photoUrl) {
          const img = document.createElement("img");
          img.src = pet.photoUrl;
          img.alt = "";
          av.appendChild(img);
        } else {
          av.textContent = (pet.name || "?")[0].toUpperCase();
        }

        const nameEl = document.createElement("span");
        nameEl.textContent = pet.name || "Câine";

        pill.appendChild(av);
        pill.appendChild(nameEl);
        sel.appendChild(pill);

        pill.addEventListener("click", () => this._switchPet(pet.id));
      });

      return sel;
    }

    _bindTabs(tabsEl) {
      tabsEl.addEventListener("click", (e) => {
        const tab = e.target.closest(".ph-tab");
        if (!tab) return;
        const name = tab.dataset.tab;

        tabsEl.querySelectorAll(".ph-tab").forEach(t => t.classList.remove("ph-tab--active"));
        tab.classList.add("ph-tab--active");

        const weightPanel = this._shadow.querySelector("#ph-panel-weight");
        const diagPanel   = this._shadow.querySelector("#ph-panel-diagnostics");
        const medPanel    = this._shadow.querySelector("#ph-panel-medical");

        weightPanel.classList.toggle("ph-panel--hidden", name !== "weight");
        diagPanel.classList.toggle("ph-panel--hidden",   name !== "diagnostics");
        medPanel.classList.toggle("ph-panel--hidden",    name !== "medical");

        if (name === "diagnostics" && !this._diagMounted) {
          this._diagProfile.render(diagPanel);
          this._diagMounted = true;
        }
        if (name === "medical" && !this._medMounted) {
          this._medicalProfile.render(medPanel);
          this._medMounted = true;
        }
      });
    }

    _showError(msg) {
      const existing = this._shadow.querySelector(".ph-global-error");
      if (existing) existing.remove();

      const err = document.createElement("div");
      err.className = "ph-error ph-global-error";
      err.textContent = String(msg);
      err.style.cssText = "position:absolute;top:0;left:0;right:0;z-index:10;border-radius:0";

      const widget = this._shadow.querySelector(".ph-widget");
      if (widget) {
        widget.style.position = "relative";
        widget.insertBefore(err, widget.firstChild);
        setTimeout(() => err.remove(), 5000);
      }
    }

    static init(config) {
      return new PetHealth(config);
    }
  }

  return PetHealth;

})();
